var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredBankSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13L23.1743 13.4243C23.3074 13.2911 23.3703 13.1032 23.3442 12.9168C23.3181 12.7303 23.206 12.567 23.0414 12.4755L22.75 13ZM9.25 13L8.95861 12.4755C8.79403 12.567 8.68191 12.7303 8.6558 12.9168C8.62969 13.1032 8.69261 13.2911 8.82574 13.4243L9.25 13ZM10 13.75L9.57574 14.1743C9.68826 14.2868 9.84087 14.35 10 14.35L10 13.75ZM22 13.75L22 14.35C22.1591 14.35 22.3117 14.2868 22.4243 14.1743L22 13.75ZM15.776 9.37445L16.0674 9.89894L15.776 9.37445ZM15.8573 9.33221L16.0856 9.88705L15.8573 9.33221ZM16.224 9.37445L15.9326 9.89894L16.224 9.37445ZM16.1427 9.33221L16.3711 8.77737L16.1427 9.33221ZM9.54139 13.5245L16.0674 9.89894L15.4846 8.84995L8.95861 12.4755L9.54139 13.5245ZM15.9326 9.89894L22.4586 13.5245L23.0414 12.4755L16.5154 8.84995L15.9326 9.89894ZM10.4243 13.3257L9.67426 12.5757L8.82574 13.4243L9.57574 14.1743L10.4243 13.3257ZM22.3257 12.5757L21.5757 13.3257L22.4243 14.1743L23.1743 13.4243L22.3257 12.5757ZM22 13.15L10 13.15L10 14.35L22 14.35L22 13.15ZM16.0674 9.89894C16.0779 9.89311 16.0855 9.88886 16.0921 9.88525C16.0986 9.88167 16.1021 9.87979 16.104 9.87881C16.1073 9.87705 16.0993 9.88144 16.0856 9.88705L15.6289 8.77737C15.5686 8.80219 15.5126 8.83443 15.4846 8.84995L16.0674 9.89894ZM16.5154 8.84995C16.4874 8.83443 16.4314 8.80219 16.3711 8.77737L15.9144 9.88705C15.9007 9.88144 15.8927 9.87705 15.896 9.87881C15.8979 9.87979 15.9014 9.88167 15.9079 9.88525C15.9145 9.88886 15.9221 9.89311 15.9326 9.89894L16.5154 8.84995ZM16.0856 9.88705C16.0308 9.90963 15.9692 9.90963 15.9144 9.88705L16.3711 8.77737C16.1334 8.67952 15.8666 8.67952 15.6289 8.77737L16.0856 9.88705Z",
    fill: "#20242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 22H22.75",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.625V20.125",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.625V20.125",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.625V20.125",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.625V20.125",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredBankSmall);
export default __webpack_public_path__ + "static/media/ic-colored-bank-small.391e8233f5dab66a54b6ae70221c6249.svg";
export { ForwardRef as ReactComponent };